// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"c6d0c11d","outerContainer":"_21dcc595","secondaryToolbar":"_97ce8eb5","doorHangerRight":"e5ba6288","toolbarContainer":"_4acc8a42","toolbarViewerMiddle":"_8df35bd4","progressBar":"_4daef37d","back-to-application":"_734272f4","root":"_57ea0cc1","header":"bd99860d","leftSideWrapper":"_1a9942d5","iconType":"e524d4e2","contentWrapper":"_757cb68a","title":"_0e0f7330","description":"_698c4d3e","rightBlock":"_2d69fc7d","date":"a6533b09","icon":"_30f8899a","activeDrugRoot":"_18461333","activeContent":"c0c57488","drugName":"be5ef78b","privacyIcon":"_94a51890"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/RefillCard/index.styl
// module id = 5051
// module chunks = 39